module.exports = __webpack_public_path__ + "static/media/performance_report.5af0c25a.png";